module.exports = __webpack_public_path__ + "static/automate-io-a7a6b20b9769f7cfde817577a7032dc0.png";